
// #721 spec §8.4 / A.12: static comparison, auto-on for moves between MAPD and Supp.
import card from '~/mixins/card'
import { suppVsMaRows } from '~/util/aep-recommendation'

export default {
    mixins: [card],
    computed: {
        table: () => suppVsMaRows(),
    },
}
